module.exports = function (page, totalPages, classPrefix) {
    var pagination = document.createElement('div');
    pagination.className = classPrefix;

    var paginationContainer = document.createElement('div');
    paginationContainer.className = classPrefix + '__container';

    if (page > 0) {
        var prev = document.createElement('a');
        prev.className = classPrefix + '__prev';
        prev.href = "#";
        prev.setAttribute('data-pagination-page', page);
        
        var prevText = document.createTextNode("Page " + page);
        prev.appendChild(prevText);

        paginationContainer.appendChild(prev);
    }

    var current = document.createElement('span');
    current.className = classPrefix + '__current';
    var currentText = document.createTextNode(page + 1);
    current.appendChild(currentText);
    paginationContainer.appendChild(current);

    if (page < totalPages - 1) {
        var next = document.createElement('a');
        next.className = classPrefix + '__next';
        next.href = "#";
        next.setAttribute('data-pagination-page', page + 2);

        var nextText = document.createTextNode("Page " + (page + 2));
        next.appendChild(nextText);

        paginationContainer.appendChild(next);
    }

    var subpagination = document.createElement('div');
    subpagination.className = classPrefix + '__subpagination';

    var subpaginationText = document.createTextNode('Jump to page');
    subpagination.appendChild(subpaginationText);

    if (page > 0) {
        var first = document.createElement('a');
        first.href = '#';
        first.setAttribute('data-pagination-page', '1');
        first.className = classPrefix + '__subpagination-link';

        var firstText = document.createTextNode('First');
        first.appendChild(firstText);

        subpagination.appendChild(first);
    }

    if (page + 1 < totalPages) {
        var inBetweenSubPaginationLinkStart = page + 3;
        var inBetweenSubPaginationLinkEnd = Math.min(page + 7, totalPages - 1);

        if (inBetweenSubPaginationLinkStart <= inBetweenSubPaginationLinkEnd) {
            if (page > 0) {
                var spacingFirst = document.createElement('span');
                spacingFirst.className = classPrefix + '__subpagination-spacing';
                subpagination.appendChild(spacingFirst);
            }

            for (var i = inBetweenSubPaginationLinkStart; i <= inBetweenSubPaginationLinkEnd; ++i) {
                var link = document.createElement('a');
                link.href = '#';
                link.setAttribute('data-pagination-page', i);
                link.className = classPrefix + '__subpagination-link';

                var linkText = document.createTextNode(i);
                link.appendChild(linkText);

                subpagination.appendChild(link);
            }
        }

        var spacingLast = document.createElement('span');
        spacingLast.className = classPrefix + '__subpagination-spacing';
        subpagination.appendChild(spacingLast);

        var last = document.createElement('a');
        last.href = '#';
        last.setAttribute('data-pagination-page', totalPages);
        last.className = classPrefix + '__subpagination-link';

        var lastText = document.createTextNode('Last');
        last.appendChild(lastText);

        subpagination.appendChild(last);
    }

    paginationContainer.appendChild(subpagination);

    pagination.appendChild(paginationContainer);

    return pagination;
};